<template>
    <transition name="fadeHeight">
        <div class="alert vue-alert border-radius" v-if="alert.message !== ''" :class="alert.status" role="alert">
            <button v-on:click="hideAlert()" type="button" class="close">
                <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="alert-heading m-0">{{ alert.message }}</h5>
        </div>
    </transition>
</template>

<script type="text/javascript">
export default {
    name: "product-alerts",
    props: {
        status: {
            type: Object
        },
        timeout: {
            type: [String, Number],
            default: 20000
        }
    },
    data() {
        return {
            alert: this.status,
            toastTriggered: false,
            countdown: null
        };
    },
    computed: {
        timeOutValue() {
            return this.alert.timeOut || this.timeOut;
        }
    },
    methods: {
        removeAlerts() {
            let existingAlerts = [...document.querySelectorAll(".alert")];

            if (existingAlerts.length) {
                existingAlerts.forEach(alert => {
                    if (!alert.classList.contains("vue-alert")) {
                        alert.remove();
                    }
                });
            }
        },
        hideAlert() {
            this.clearCountdown();
            this.alert.message = "";
        },
        displayAlert() {
            this.clearCountdown();

            this.countdown = setTimeout(
                function() {
                    this.alert.message = "";
                    this.alert.status = "";
                    this.countdown = null;
                }.bind(this),
                this.timeOutValue
            );
        },
        clearCountdown() {
            if (this.countdown) {
                clearTimeout(this.countdown);
                this.countdown = null;
            }
        }
    },
    mounted() {
        // remove any existing Laravel flash message alerts if present
        // and if user has not already triggered a toast
        this.countdown = setTimeout(
            function() {
                if (!this.toastTriggered) {
                    this.removeAlerts();
                }
            }.bind(this),
            this.timeOutValue
        );
    },
    beforeDestroy() {
        this.clearCountdown();
    },
    watch: {
        alert: {
            handler: function() {
                if (this.alert.message === "") {
                    this.hideAlert();
                } else {
                    if (!this.toastTriggered) {
                        this.removeAlerts();
                        this.toastTriggered = true;
                    }

                    this.displayAlert();
                }
            },
            deep: true
        },
        status: {
            handler: function() {
                if (this.status.message === "" && this.status.message !== this.alert.message) {
                    this.hideAlert();
                } else if (this.alert.message !== this.status.message) {
                    this.alert.message = this.status.message;
                    this.alert.status = this.status.status;
                }
            },
            deep: true
        }
    }
};
</script>

<style scoped lang="css">
    .alert{
        padding: 9px 20px;
        border-radius: 2px;
        position: fixed;
        top: 8rem;
        right: 2rem;
        min-width: 18rem;
        max-width: 24rem;
        width: 100%;
        z-index: 1040;
        overflow: hidden;
        display: inline-flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        align-items: center;
    }

    .alert.alert-success {
        color: #164220 !important;
        border-color: #b9e8cd !important;
        background: #e6f7ea !important;
    }

    .alert.alert-danger {
        color: #581c21 !important;
        border-color: #f1d2cc !important;
        background: #fbeaec !important;
    }

    .alert.alert-info {
        color: #0c7b94 !important;
        border-color: #02a7cd !important;
        background: rgba(206, 245, 255, 0.7) !important;
    }

    .fadeHeight-enter-active,
    .fadeHeight-leave-active {
      transition: all 0.2s;
      max-height: 200px;
    }

    .fadeHeight-enter,
    .fadeHeight-leave-to {
      opacity: 0;
      max-height: 0px;
    }
</style>
